export const BOOKINGS_ROUTE_PREFIX: string = '/dashboard/bookings';

interface BookingsRoutes {
  details: {
    getUrl: (id: string, tab?: string) => string;
    path: string;
    relativePath: string;
  };
  index: {
    getUrl: (scopeSlug?: string) => string;
    path: string;
    relativePath: string;
  };
}

const bookingsRoutes: BookingsRoutes = {
  details: {
    path: `${BOOKINGS_ROUTE_PREFIX}/details/:id/:tab?`,
    getUrl: (id: string, tab?: string): string => {
      const url: string = `${BOOKINGS_ROUTE_PREFIX}/details/${id}`;

      if (!tab) {
        return url;
      }

      return `${url}/${tab}`;
    },
    relativePath: 'bookings/details/:id/:tab?'
  },
  index: {
    path: `${BOOKINGS_ROUTE_PREFIX}/:scope?`,
    getUrl: (scopeSlug?: string): string => {
      if (!scopeSlug) {
        return BOOKINGS_ROUTE_PREFIX;
      }

      return `${BOOKINGS_ROUTE_PREFIX}/${scopeSlug}`;
    },
    relativePath: 'bookings/:scope?'
  }
};

export default bookingsRoutes;
